import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProgramsOptions } from '../../../redux/slices/customer/trainingSlice';

const ProgramsModal = ({ isOpen, onClose, setSelectedProgram, selectedProgram, selectedWeek}) => {
  const dispatch = useDispatch();

  const { programs_options } = useSelector((state) => state.customer_training);

  const [selectedProgramInner, setSelectedProgramInner] = useState(null);

  const handleSubmit = () => {
    const confirmed = window.confirm("Are you sure you want to choose this program?");  
    if (confirmed) {
      setSelectedProgram(selectedProgramInner);
    }    
  }  

  useEffect(() => {
    if (isOpen) {
      dispatch(getProgramsOptions(selectedWeek));
    }
  }, [isOpen, dispatch, selectedWeek]);

  return isOpen ? (
    <div className="modal fade show replace-exercise-modal" style={{ display: "block" }} aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header justify-content-center">
            <h5 className="modal-title">You don't have a training program yet.</h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <p>Choose one of our pre-built programs below:</p>

              <div className="radio-wrap flex flex-col gap-sm" style={{maxHeight:'500px', overflow:'auto'}}>
                {programs_options && programs_options.map((program) => (
                  <div
                    key={program.id}
                    onClick={() => setSelectedProgramInner(program.id)}
                    className="radio-group flex align-center justify-center"
                  >
                    <input
                      type="radio"
                      id={`program-${program.id}`}
                      name="program"
                      checked={selectedProgramInner === program.id}
                      onChange={() => setSelectedProgramInner(program.id)}
                    />
                    <label className="radio-label" htmlFor={`program-${program.id}`}>
                      {program.program_name}
                    </label>
                  </div>
                ))}
              </div>

              <div className="form-group">
                <button className="btn-red" type="submit" onClick={handleSubmit}>
                  Choose Program
                </button>
              </div>
            
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default ProgramsModal;